
const localeToConditionsUrl: {[locale: string]: string} = {
    "fr_FR": `https://docs.travelski.com/legal-docs/www.travelski.com/CGV/index.pdf`,
    "fr_FR_CSE": `https://docs.travelski.com/legal-docs/www.travelski.com/CGV/index.pdf`,
    "nl_NL": `https://docs.travelski.com/legal-docs/www.nl.travelski.com/CGV/index.pdf`,
    "en_US": `https://docs.travelski.com/legal-docs/www.uk.travelski.com/CGV/index.pdf`,
}

const yoonlyDomainToConditionsUrl: { [domain: string]: string } = {
  "www.nl.yoonly.eu": 'https://docs.travelski.com/legal-docs/www.nl.yoonly.eu/CGV/index.pdf',
  "www.benl.yoonly.eu": 'https://docs.travelski.com/legal-docs/www.benl.yoonly.eu/CGV/index.pdf',
  "www.befr.yoonly.eu": 'https://docs.travelski.com/legal-docs/www.befr.yoonly.eu/CGV/index.pdf',
  "www.yoonly.eu": 'https://docs.travelski.com/legal-docs/www.befr.yoonly.eu/CGV/index.pdf', // www.yoonly.eu  is the same as www.befr.yoonly.eu
}

export const TRAVELSKI_EXPRESS_TERMS_URL = `https://docs.travelski.com/legal-docs/CG_SERVICE_DE_TRANSPORT_FERROVIAIRE-10-25.pdf`

export default {
  ...localeToConditionsUrl,
  ...yoonlyDomainToConditionsUrl,
}